<template>
	<div class="tabbar_box" :class="darkmode?'darkmode':''">
		<van-tabbar v-model="active" active-color="var(--footact-color)" inactive-color="var(--foot-color)" route @change="onChange">
			<van-tabbar-item :class="isHideVideo?'HideItem':''"  to="/index">
				<span>{{$t('message.home')}}</span>
				<template #icon="props">
					<a class="Fta" :class="{ 'Ftao': props.active }"><span
							class="iconfontll icon-rhome-fill"></span></a>
				</template>
			</van-tabbar-item>
			<van-tabbar-item  to="/games">
				<span>{{$t('message.game')}}</span>
				<template #icon="props">
					<a class="Fta" :class="{ 'Ftao': props.active }"><span class="iconfontll icon-youxi"></span></a>
				</template>
			</van-tabbar-item>
			<van-tabbar-item  :to="!isLogin?'/login':'/collect'">
				<span>{{$t('message.collect')}}</span>
				<template #icon="props">
					<a class="Fta" :class="{ 'Ftao': props.active }"><span class="iconfontll icon-shoucang"></span></a>
				</template>
			</van-tabbar-item>
			<!-- <van-tabbar-item to="/money">
      <span>{{$t('message.wallet')}}</span>
      <template #icon="props">
        	<a class="Fta" :class="{ 'Ftao': props.active }"><span class="wapiconfont icon-qianbao"></span></a>
      </template>
    </van-tabbar-item> -->
			<van-tabbar-item  :to="!isLogin?'/login':'/recharge'">
				<span>{{$t('message.recharge')}}</span>
				<template #icon="props">
					<a class="Fta" :class="{ 'Ftao': props.active }"><span class="iconfontll icon-chongzhi"></span></a>
				</template>
			</van-tabbar-item>
			<van-tabbar-item  to="/my">
				<span>{{$t('message.my')}}</span>
				<template #icon="props">
					<a class="Fta" :class="{ 'Ftao': props.active }"><span class="iconfontll icon-wode1"></span></a>
				</template>
			</van-tabbar-item>
			<!-- <van-tabbar-item icon="wap-home-o" replace to="/">首页</van-tabbar-item>
    <van-tabbar-item icon="point-gift-o" replace to="/activity">游戏</van-tabbar-item>
    <van-tabbar-item icon="pending-payment" replace to="/home">收藏</van-tabbar-item>
    <van-tabbar-item icon="icon-liwu" replace to="/home">充值</van-tabbar-item>
    <van-tabbar-item icon="manager" replace to="/home">我的</van-tabbar-item> -->
		</van-tabbar>
	</div>
</template>

<script>
	import {
		getHideVideo
	} from "@/assets/wap/js/hideJs";
	export default {
		name: 'tabbar',
		data() {
			return {
				isHideVideo:false,//是否隐藏视频
				active: 0,
				icon: {
					active: 'https://img01.yzcdn.cn/vant/user-active.png',
					inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png',
					darkmode: false, //是否夜间模式
					
				},
				isLogin: false, //是否登录
			};
		},
		created() {
			if (this.$store.state.token != '') {
				this.isLogin = true;
			} else {
				this.isLogin = false;
			}
			// 获取黑白模式
			var darkmodeval = this.$store.state.darkmode;
			// console.log("darkmodeval", darkmodeval)
			if (darkmodeval != null) {
				this.darkmode = darkmodeval;
				// if (darkmodeval) {
				// 	this.modeicon = require('@/assets/wap/images/icon/moon.svg');
				// 	this.modetext = "白天模式";
				// } else {
				// 	this.modeicon = require('@/assets/wap/images/icon/sun.svg');
				// 	this.modetext = "深夜模式";
				// }
			}
			this.isHideVideo =this.$store.state.isHideVideo;
			console.log(this.isHideVideo,"isHideVideo")
			getHideVideo(0)//隐藏视频公共js
		},
		methods: {
			onChange(index) {
				console.log("底部",index)
				if (index == 2||index ==3) {
					//判断是否登录
					if (this.$store.state.token == '') {
						this.$toast(this.$t('message.plogin'));
						// this.$router.push({
						// 	name: 'login'
						// });
						// return false;
					}
				}
			},
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-tabbar {
		background-color: var(--bg-color);
	}

	/deep/ .van-tabbar-item--active {
		background-color: var(--bg-color);
	}

	/deep/ .van-tabbar::after {
		border: 0 solid var(--border-color);
		border-width: 1px 0;
	}

	a.Fta {
		color:var(--foot-color);

		span.iconfontll {
			margin: 0 auto 0.01rem;
			// font-size: 22px;
		}
	}

	// 选中图标颜色
	a.Ftao {
		color:var(--footact-color);
	}
	.HideItem{
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/wap/public/tabbar.vue